import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
    createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as inventoryApi from '../../lib/api/inventory';

// 창고 목록
const [LIST_WH_MASTER, LIST_WH_MASTER_SUCCESS, LIST_WH_MASTER_FAILURE] =
    createRequestActionTypes('inventory/LIST_WH_MASTER');
export const listWhMaster = createAction(
    LIST_WH_MASTER,
    (searchData) => searchData,
);
const listWhMasterSaga = createRequestSaga(
    LIST_WH_MASTER,
    inventoryApi.getWarehouseList,
);

const UNLOAD_WH_MASTER = 'inventory/UNLOAD_WH_MASTER';
export const unloadWhMaster = createAction(UNLOAD_WH_MASTER);

export function* whMasterSaga() {
    yield takeLatest(LIST_WH_MASTER, listWhMasterSaga);
}

const initialState = {
    warehouses: null,
    error: null,
};

const whMaster = handleActions(
    {
        [LIST_WH_MASTER_SUCCESS]: (state, { payload: data }) => ({
            ...state,
            warehouses: data.list
                ? data.list.map((wh) => ({
                    id: wh.whUuid,
                    whUuid: wh.whUuid,
                    whNm: wh.whNm,
                    whDesc: wh.whDesc,
                    whAddr: wh.whAddr,
                    whCate1: wh.whCate1,
                    whCate2: wh.whCate2,
                    isDefault: wh.isDefault,
                    stockCount: wh.stockCount,
                    totalQty: wh.totalQty,
                    crtNm: wh.crtNm,
                    crtDt: wh.crtDt,
                }))
                : [],
            error: null,
        }),
        [LIST_WH_MASTER_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error: error,
        }),
        [UNLOAD_WH_MASTER]: () => initialState,
    },
    initialState,
);

export default whMaster;
